import {createContext} from 'react'

const rentasContext = createContext()

export default rentasContext